module.exports = __webpack_public_path__ + "static/img/042_3.6accb2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_3.jpg
// module id = dI1G
// module chunks = 1